import React from 'react';
import styled from 'styled-components';
import chroma from 'chroma-js';

const cardColor = chroma('#fee083');

const Container = styled.div`
  background-color: ${cardColor.hex()};
  border-bottom: 2px solid ${cardColor.darken().hex()};
  border-radius: 1rem;
  font-family: sans-serif;
  padding-top: 1.5rem;
  width: 245px;
`;

const Title = styled.div`
  font-weight: 700;
  text-align: center;
  background: black;
  line-height: 2rem;
  color: black;
`;

const NumberHighlight = styled.div`
  border: 2px solid red;
  padding: 0.1rem 0.5rem;
  border-radius: 0.5rem;
`;

const BottomSection = styled.div`
  padding: 1.5rem;
  display: grid;
  grid-template-columns: 4fr 1fr;
  grid-column-gap: 1rem;
`;

const CardNumberDisplay = styled.div`
  background: white;
  clear: both;
`;

export default () => (
  <Container>
    <Title>CREDIT CARD</Title>
    <BottomSection>
      <CardNumberDisplay />
      <NumberHighlight>123</NumberHighlight>
    </BottomSection>
  </Container>
);
